module.exports = __webpack_public_path__ + "static/media/usecase.555413d8.png";